/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
